/**
 * Utility functions for URL validation and expiration checking.
 *
 * @module utils/url
 * @author Snowfly
 * @version 1.0.0
 */

/**
 * Determines whether a given URL has expired based on its query parameter
 *      `X-Amz-Date`.
 *
 * This function extracts the `X-Amz-Date` parameter from the URL, parses it
 * into a date object, and checks if the current time is later than 4 minutes
 * after the specified timestamp. If the `X-Amz-Date` parameter is not present
 * in the URL, the function assumes the URL is expired.
 *
 * @param {string} url - The URL to be checked for expiration.
 * @returns {boolean} - Returns `true` if the URL is expired or the required
 *      parameter is missing, otherwise returns `false`.
 */
export const isUrlExpired = (url) => {
    if (!url?.length) {
        return true;
    }

    const urlParams = new URLSearchParams(new URL(url).search);
    const amzDate = urlParams.get('X-Amz-Date');
    let result = true;

    if (amzDate) {
        let y = amzDate.slice(0, 4),
            mo = amzDate.slice(4, 6),
            d = amzDate.slice(6, 8),
            h = amzDate.slice(9, 11),
            mi = amzDate.slice(11, 13),
            s = amzDate.slice(13, 15);
        const expirationTime = new Date(
            `${y}-${mo}-${d}T${h}:${mi}:${s}Z`
        );

        expirationTime.setMinutes(expirationTime.getMinutes() + 4);
        result = (new Date() > expirationTime);
    }

    return result;
};